import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93a1db30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tress-modal__header" }

import { ref, watch } from "vue";
import IconCloseModal from "@/components/icons/IconCloseModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressModal',
  props: {
  isOpen: {
    type: Boolean,
    required: false,
  },
},
  emits: {
  open: () => true,
  close: () => true,
},
  setup(__props, { emit }) {

const props = __props;



const isOpen = ref<boolean>(props.isOpen);
const open = () => {
  isOpen.value = true;
  emit("open");
};
const close = () => {
  isOpen.value = false;
  emit("close");
};
watch(
  () => props.isOpen,
  (currVal: boolean) => {
    isOpen.value = currVal;
  }
);

return (_ctx: any,_cache: any) => {
  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tress-modal-container",
        onClick: close
      }, [
        _createElementVNode("div", {
          class: "tress-modal",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "header"),
            _createElementVNode("button", {
              class: "swal2-close",
              type: "button",
              onClick: close
            }, [
              _createVNode(IconCloseModal)
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {
            isOpen: isOpen.value,
            open: open,
            close: close
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})